import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceParams',
    standalone: false
})
export class ReplaceParamsPipe implements PipeTransform {

  transform(value: string, paramId: string): string {
    let newValue: string = value.replace(':id', paramId);

    if(newValue !== value)
      newValue = '# ' + newValue;
    
      return newValue;
  }

}
